import { defineMessages } from 'react-intl';
import type { RaceEthnicityEnum } from '@foundershub/api-client';

export const raceEthnicityLabels = defineMessages<RaceEthnicityEnum>({
  'african-americanblack': {
    defaultMessage: 'African-American/Black',
    description: 'Race/ethnicity option label',
  },
  'hispaniclatino-american': {
    defaultMessage: 'Hispanic/Latino-American',
    description: 'Race/ethnicity option label',
  },
  'native-american': {
    defaultMessage: 'Native American',
    description: 'Race/ethnicity option label',
  },
  indigenous: {
    defaultMessage: 'Indigenous',
    description: 'Race/ethnicity option label',
  },
  'asian-pacific-american': {
    defaultMessage: 'Asian-Pacific American',
    description: 'Race/ethnicity option label',
  },
  'asian-indian-american': {
    defaultMessage: 'Asian-Indian American',
    description: 'Race/ethnicity option label',
  },
  disability: {
    defaultMessage: 'Disabled',
    description: 'Race/ethnicity option label',
  },
  veteran: {
    defaultMessage: 'Veteran',
    description: 'Race/ethnicity option label',
  },
  lgbtiq: {
    defaultMessage: 'LGBTIQ+',
    description: 'Race/ethnicity option label',
  },
});
